import { Navigate, useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth0()
  let location = useLocation()

  return isAuthenticated === true ? children : <Navigate to='/' state={{ from: location }} replace />
}

export default PrivateRoute
